import { render, staticRenderFns } from "./EstimateTemplatesPopup.vue?vue&type=template&id=67dbc464&scoped=true&"
import script from "./EstimateTemplatesPopup.vue?vue&type=script&lang=js&"
export * from "./EstimateTemplatesPopup.vue?vue&type=script&lang=js&"
import style0 from "./EstimateTemplatesPopup.vue?vue&type=style&index=0&id=67dbc464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dbc464",
  null
  
)

export default component.exports